export default "__VITE_ASSET__BerN2zn9__"